import { fromFetch } from 'rxjs/fetch';

import { requiredHeaders } from '../../../models/required-headers';
import { TidAuthHeaders } from '../../../models/tid-auth-headers';
import { selectData } from '../../../utils/select-data';
import { userinfoSchema } from '../schemas/userinfo.schema';
import { trimbleIdentityEnvironment } from '../trimble-identity-environment';

/**
 * Get User information about authenticated user from Trimble Cloud
 * @returns information about authenticated user from Trimble Cloud
 */
export function getUserinfo(this: unknown) {
  return fromFetch(
    new Request(trimbleIdentityEnvironment.resolve(this).userInfoUrl, {
      method: 'GET',
      headers: {
        ...requiredHeaders,
        ...new TidAuthHeaders(),
      },
    })
  ).pipe(selectData(userinfoSchema));
}
